export default __webpack_public_path__ + "static/media/logout.0f2fb8b5.svg";